__turbopack_context__.v({
  "link": "menu-link-module__p6NtpW__link",
});
